import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _goBackTo$ = new BehaviorSubject<string | null>(null);
  goBackTo$ = this._goBackTo$.asObservable();

  setGoBackTo(path: string | null) {
    this._goBackTo$.next(path);
  }
}